import { Box, Center, Stack, Text } from '@chakra-ui/react'
import React, { useState, useEffect } from 'react'

import Button from '../Components/Button';
import { useNavigate } from 'react-router-dom';
import { GetToken, signIn } from '../Utils/ApiCalls';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { authenticate } from '../Authetication';


export default function LoginPage() {

    const isAuthenticated = useIsAuthenticated()
    const [Loading, setLoading] = useState(false);


    console.log("auth", isAuthenticated)
    const navigate = useNavigate();
    const { instance } = useMsal();

    const Logout = () => {
        localStorage.clear("accessToken")
        localStorage.clear("ImsToken")
        instance.logoutRedirect({
            scopes: ['user.read']
        })

    }

    const handleSign = () => {
        setLoading(true)
        instance.loginRedirect({
            scopes: ['user.read']
        })


    }

    const [Error, setError] = useState({
        msg: "",
        status: false
    });

// const [CountDown, setCountDown] = useState(10);

// let CountDown =  10
// setInterval(() => {
   
//     CountDown++ 

    
//     console.log(CountDown)
//    }, 3000);


    let accessToken = localStorage.getItem("accessToken")
    
    console.log("accessToken", accessToken)

    if (isAuthenticated) {
       

        const ReceiveToken = async () => {
            let result = await GetToken(accessToken)

            console.log("resultToken", result);

            if (result.status === true) {
                authenticate(result)
                setError({
                    status: false
                })
                
                navigate("/dashboard")
            } else {

                setError({
                    msg: result.msg,
                    status: true
                })
               

                setTimeout(() => {
                    
                    Logout()
                }, 10000);
                console.log("authication error", result)
            }
        }

        ReceiveToken()
    }

    






    return (
        <Box  h="100vh" minH={"100vh"} bgImage="linear-gradient(to bottom right, #0f034f, #6c5ad2)}">

            <Text fontSize="30px" textAlign="center" fontWeight={800} color="orange.orange500" pt="25vh">IMS</Text>
            <Center>
                <Box w={["80%", "60%", "50%", "35%", "30%"]}
                    bgColor={"blue.blue300"} p="30px" mt="20px" borderRadius={"8px"} color={"#fff"} >
                    {
                        isAuthenticated ? (
                            <Text fontSize={"18px"}>Welcome</Text>
                        ) : (
                            <Text fontSize={"18px"}>Sign in</Text>
                        )
                    }

                    <Text fontSize={"12px"} mt="10px" color="gray.gray100">{isAuthenticated ? "Logout from " : "Login with "} EKEDP credentials </Text>

                    <Button mt="25px" background='orange.orange500' color='#242424' isLoading={Loading} onClick={handleSign}>Sign in</Button>

                    {/* <Button mt="25px" background='red' isLoading={Loading} onClick={handleSign}>Sign in</Button> */}
                    {
                        Error.status && (

                            <Text mt="10px" color="red.red300" textAlign={"center"} fontSize="14px">{Error.msg} </Text>
                        )
                    }




                </Box>

            </Center>
        </Box>
    )
}
